import { ColumnState } from 'ag-grid-community';
import { DateRange } from 'react-day-picker';
import { create } from 'zustand';
import { defaultMST3040_R01DetailDto, defaultMST3040_R01HeaderDto, defaultMST3040_R01UsageDto, MST3040_R01DetailDto, MST3040_R01HeaderDto, MST3040_R01UsageDto } from './Dto_MST3040_R01';
import { showWarning } from 'src/utils/toast/toastUtil';


export interface MST3040_R01Filter {
	brandCd: string;
	itemGroup: string;
	itemAccount: string;
	prntItemcd: string;
	prntItemnm: string;
}
export interface Store_MST3040_R01 {
	MST3040_R01Filter: MST3040_R01Filter;
	MST3040_R01PastFilter: MST3040_R01Filter;
	setMST3040_R01Filter: (filter: Partial<Store_MST3040_R01['MST3040_R01Filter']>) => void;
	setMST3040_R01PastFilter: (filter: Store_MST3040_R01['MST3040_R01PastFilter']) => void;
	
	// ====== 매출 리스트 및 선택/편집 ======
	MST3040_R01List: MST3040_R01HeaderDto[];
	setMST3040_R01List: (dataList: MST3040_R01HeaderDto[]) => void;

	editMST3040_R01: MST3040_R01HeaderDto | null;
	setEditMST3040_R01: (editSale: MST3040_R01HeaderDto | null) => void;

	selectedMST3040_R01: MST3040_R01HeaderDto | undefined;
	setSelectedMST3040_R01: (data: MST3040_R01HeaderDto | undefined) => void;
	initSelectedMST3040_R01: () => void;

	// ====== 매출 상세(디테일) 데이터 ======
	MST3040_R01DetailList: MST3040_R01DetailDto[];
	setMST3040_R01DetailList: (data: MST3040_R01DetailDto[]) => void;
	insertMST3040_R01DetailList: (data: MST3040_R01DetailDto[], index?: number) => void;
	removeMST3040_R01DetailList: (index: number) => void;
	updateMST3040_R01DetailList: (index: number, data: MST3040_R01DetailDto) => void;

	// ====== 선택(디테일) 행 선택/삭제 관리 ======
	selectedMST3040_R01DetailList: string[];
	setSelectedMST3040_R01DetailList: (idList: string[]) => void;
	addSelectedMST3040_R01DetailList: (idList: string[]) => void;
	removeSelectedMST3040_R01DetailList: (idList?: string[]) => void;
	initSelectedMST3040_R01DetailList: () => void;

	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedMST3040_R01DetailList: string[];
	setDeletedMST3040_R01DetailList: (idList: string[]) => void;
	addDeletedMST3040_R01DetailList: (idList: string[]) => void;
	removeDeletedMST3040_R01DetailList: (idList?: string[]) => void;

	editMST3040_R01Detail: MST3040_R01DetailDto | null;
	setEditMST3040_R01Detail: (editDetail: MST3040_R01DetailDto | null) => void;

	originalMST3040_R01DetailList: MST3040_R01DetailDto[];
	setOriginalMST3040_R01DetailList: (data: MST3040_R01DetailDto[]) => void;

	// ====== BOM 좌표정보 대조(소요량) 데이터 ======
	MST3040_R01UsageList: MST3040_R01UsageDto[];
	setMST3040_R01UsageList: (data: MST3040_R01UsageDto[]) => void;
	insertMST3040_R01UsageList: (data: MST3040_R01UsageDto[], index?: number) => void;
	removeMST3040_R01UsageList: (index: number) => void;
	updateMST3040_R01UsageList: (index: number, data: MST3040_R01UsageDto) => void;

	// ====== BOM 좌표정보 대조(사용량) 행 선택/삭제 관리 ======
	selectedMST3040_R01Usage: MST3040_R01UsageDto | undefined;
	setSelectedMST3040_R01Usage: (data: MST3040_R01UsageDto | undefined) => void;
	initSelectedMST3040_R01Usage: () => void

	originalMST3040_R01UsageList: MST3040_R01UsageDto[];
	setOriginalMST3040_R01UsageList: (data: MST3040_R01UsageDto[]) => void;

	// ====== 컬럼 상태(그리드) ======
	columnState: ColumnState[] | null;			setColumnState: (state: ColumnState[] | null) => void;
	detailColumnState: ColumnState[] | null;	setDetailColumnState: (state: ColumnState[] | null) => void;
	usageColumnState: ColumnState[] | null;			setUsageColumnState: (state: ColumnState[] | null) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;
	detailScrollTop: number | null;
	setDetailScrollTop: (top: number | null) => void;
	usageScrollTop: number | null;
	setUsageScrollTop: (top: number | null) => void;

	allCount: number;				setAllCount: (allCount: number) => void;
	modalVisible: boolean;			setModalVisible: (visible: boolean) => void;
	detailFetchTrigger: boolean;
	setDetailFetchTrigger: (trigger: boolean) => void;

	// ====== 초기화 ======
	initData: () => void;

}

export const defaultMST3040_R01Filter : MST3040_R01Filter = {
	brandCd: '',
	itemGroup: '',
	itemAccount: '',
	prntItemcd: '',
	prntItemnm: '',
};

export const useMST3040_R01Store = create<Store_MST3040_R01>((set) => ({
	MST3040_R01Filter: defaultMST3040_R01Filter,
	MST3040_R01PastFilter: defaultMST3040_R01Filter,
	setMST3040_R01Filter: (update) => set((state) => ({
		MST3040_R01Filter: {
			...state.MST3040_R01Filter,
			...update
		}
	})),
	setMST3040_R01PastFilter: (filter: Store_MST3040_R01['MST3040_R01PastFilter']) => set((state) => {
		return {
			...state,
			MST3040_R01PastFilter: filter
		}
	}),

	// ====== 매출 리스트 및 선택/편집 ======
	MST3040_R01List: [],
	setMST3040_R01List: (dataList: MST3040_R01HeaderDto[]) => set((state) => {
		return {
			...state,
			MST3040_R01List: dataList
		}
	}),

	editMST3040_R01: defaultMST3040_R01HeaderDto,
	setEditMST3040_R01: (editSale: MST3040_R01HeaderDto | null) => set((state) => {
		return {
			...state,
			editMST3040_R01: editSale
		}
	}),

	selectedMST3040_R01: undefined,
	
	setSelectedMST3040_R01: (data: MST3040_R01HeaderDto | undefined) => set((state) => {

		return { 
			...state,
			selectedMST3040_R01: data,
			selectedMST3040_R01DetailList: [],
			deletedMST3040_R01DetailList: [],
			detailFetchTrigger: true,
		};
	}),
	initSelectedMST3040_R01: () => set({
		selectedMST3040_R01: undefined,
		editMST3040_R01: defaultMST3040_R01HeaderDto,
		editMST3040_R01Detail: defaultMST3040_R01DetailDto,
		MST3040_R01DetailList: [],
		detailFetchTrigger: false,
	}),

	// ====== 매출 상세(디테일) 데이터 ======
	MST3040_R01DetailList: [],
	setMST3040_R01DetailList: (data: MST3040_R01DetailDto[]) => set((state) => {
		let newList: MST3040_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				//...defaultMST3040_R01DetailDto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			MST3040_R01DetailList: newList
		}
	}),
	insertMST3040_R01DetailList: (data: MST3040_R01DetailDto[], index?: number) => set((state) => {
		let newMST3040_R01DetailList = [...state.MST3040_R01DetailList];

		let targetRowData = newMST3040_R01DetailList.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...newMST3040_R01DetailList.map(item => item.valueIndex || 0)) + 1;

		// newMST3040_R01DetailList에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newMST3040_R01DetailList.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newMST3040_R01DetailList에 대체
		newMST3040_R01DetailList = newMST3040_R01DetailList.filter(item => item.orderIndex !== targetOrderIndex);
		newMST3040_R01DetailList.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultMST3040_R01DetailDto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq,
			coordinateSeq: targetRowData?.coordinateSeq || 1,
		}));
		if (index !== undefined) {
			newMST3040_R01DetailList.splice(index, 0, ...newData);
		} else {
			newMST3040_R01DetailList.push(...newData);
		}
		
		return {
			...state,
			MST3040_R01DetailList: newMST3040_R01DetailList
		}
	}),
	removeMST3040_R01DetailList: (index: number) => set((state) => {
		const newMST3040_R01DetailList = [...state.MST3040_R01DetailList].filter((item) => item.valueIndex !== index);
		return {
			...state,
			MST3040_R01DetailList: newMST3040_R01DetailList
		}
	}),
	updateMST3040_R01DetailList: (valueIndex: number, data: MST3040_R01DetailDto) => set((state) => {
		const candidateList = state.MST3040_R01DetailList.map(item =>
			item.valueIndex === valueIndex ? data : item
		);

		// 하나의 피더코드를 서로 다른 자품목코드가 공유할 때 감지
		// const hasCrossChildFeederConflict = (
		// 	list: MST3040_R01DetailDto[],
		// 	feederKey: keyof MST3040_R01DetailDto
		// ): boolean => {
		// 	const feederToChildSet = new Map<string, Set<string>>();
		// 	for (const item of list) {
		// 		const feederVal = item[feederKey] as string;
		// 		const childVal = item.childItemcd;
		// 		if (!feederVal || !childVal) continue;
		// 		if (!feederToChildSet.has(feederVal)) {
		// 			feederToChildSet.set(feederVal, new Set());
		// 		}
		// 		feederToChildSet.get(feederVal)!.add(childVal);
		// 	}
		// 	const hasDiff = Array.from(feederToChildSet.values()).some(childSet => childSet.size > 1);
		// 	if (hasDiff) return true;
		// 	return false;
		// };

		// if (
		// 	hasCrossChildFeederConflict(candidateList, 'afeederCd') ||
		// 	hasCrossChildFeederConflict(candidateList, 'bfeederCd') ||
		// 	hasCrossChildFeederConflict(candidateList, 'cfeederCd')
		// ) {
		// 	showWarning('하나의 피더코드를 서로 다른 자품목코드가 공유할 수 없습니다.');
		// 	return {
		// 		...state,
		// 		MST3040_R01DetailList: state.MST3040_R01DetailList.map(item =>
		// 			item.valueIndex === valueIndex ? { ...item } : item
		// 		),
		// 	};
		// }

		return {
			...state,
			MST3040_R01DetailList: candidateList
		}
	}),
	
	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedMST3040_R01DetailList: [],
	setDeletedMST3040_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			deletedMST3040_R01DetailList: idList
		}
	}),
	addDeletedMST3040_R01DetailList: (idList: string[]) => set((state) => {
		const _deletedDetailList = [...state.deletedMST3040_R01DetailList];

		for(const valueIndex of idList) {
			const isInserted = state.MST3040_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.MST3040_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedDetailList.push(valueIndex);
			}
		}
		
		return {
			...state,
			deletedMST3040_R01DetailList: _deletedDetailList
		}
	}),
	removeDeletedMST3040_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		deletedMST3040_R01DetailList: [...state.deletedMST3040_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),

	selectedMST3040_R01DetailList: [],
	setSelectedMST3040_R01DetailList: (idList: string[]) => set((state) => {

		//맨 마지막으로 선택한 행을 editMST3040_R01Detail로 설정
		const lastRow = state.MST3040_R01DetailList[state.MST3040_R01DetailList.length - 1];

		return {
			...state,
			selectedMST3040_R01DetailList: idList,
			editMST3040_R01Detail: lastRow
		}
	}),
	addSelectedMST3040_R01DetailList: (idList: string[]) => set((state) => {
		const _selectedMST3040_R01DetailList = [...state.selectedMST3040_R01DetailList];
		if(idList.length > 0) {
			_selectedMST3040_R01DetailList.push(...idList);
		}
		return {
			...state,
			selectedMST3040_R01DetailList: _selectedMST3040_R01DetailList
		}
	}),
	removeSelectedMST3040_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		selectedMST3040_R01DetailList: [...state.selectedMST3040_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedMST3040_R01DetailList: () => set({ selectedMST3040_R01DetailList: [], editMST3040_R01Detail: defaultMST3040_R01DetailDto }),

	editMST3040_R01Detail: defaultMST3040_R01DetailDto,
	setEditMST3040_R01Detail: (editDetail: MST3040_R01DetailDto | null) => set((state) => {

		let newDetailList = state.MST3040_R01DetailList;

		// editDetail이 존재하고, valueIndex가 유효한 경우에만 detailList를 업데이트합니다.
		if (editDetail && editDetail.valueIndex) {
			newDetailList = state.MST3040_R01DetailList.map(item =>
				item.valueIndex === editDetail.valueIndex
					? { 
						...item,
						isModified: editDetail.isModified
					} // 기존 item 데이터에 변경된 editDetail 데이터를 덮어씁니다.
					: item
			);
		}

		return {
			...state,
			MST3040_R01DetailList: newDetailList, // 업데이트된 새 배열로 상태를 교체합니다.
			editMST3040_R01Detail: editDetail
		}
	}),

	originalMST3040_R01DetailList: [],
	setOriginalMST3040_R01DetailList: (data: MST3040_R01DetailDto[]) => set((state) => {
		let newList: MST3040_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
				...defaultMST3040_R01DetailDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalMST3040_R01DetailList: newList
		}
	}),

		// ====== 매출 상세(소요량) 데이터 ======
		MST3040_R01UsageList: [],
		setMST3040_R01UsageList: (data: MST3040_R01UsageDto[]) => set((state) => {
			let newList: MST3040_R01UsageDto[] = [];
			let valueAndOrderIndex = 1;
			data.forEach((item, index) => {
				// console.log(index + '번째 행의 item.Index 정보: ' 
				// 	+ ' valueIndex : ' + item.valueIndex 
				// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
				// 	+ ' orderIndex : ' + item.orderIndex 
				// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
				newList.push({ 
					//...defaultMST3040_R01UsageDto,
					...item,
					valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
					orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
					orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
				});
				valueAndOrderIndex++;
			});
			return {
				...state,
				MST3040_R01UsageList: newList
			}
		}),
		insertMST3040_R01UsageList: (data: MST3040_R01UsageDto[], index?: number) => set((state) => {
			let newMST3040_R01UsageList = [...state.MST3040_R01UsageList];
	
			let targetRowData = newMST3040_R01UsageList.find(item => item.valueIndex === index);
			let targetOrderIndex = targetRowData?.orderIndex || 0;
			// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		
	
			const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
			// console.log('targetOrderIndex : ', targetOrderIndex);
			// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
			let maxValueIndex = Math.max(0, ...newMST3040_R01UsageList.map(item => item.valueIndex || 0)) + 1;
	
			// newMST3040_R01UsageList에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
			// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
			// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
			const targetRows = newMST3040_R01UsageList.filter(item => item.orderIndex === targetOrderIndex);
			targetRows.forEach(item => {
				if(item.orderIndexSeq < newOrderIndexSeq) {
					item.orderIndexSeq = item.orderIndexSeq;
				} else if(item.orderIndexSeq >= newOrderIndexSeq) {
					item.orderIndexSeq = item.orderIndexSeq + 1;
				}
			});
	
			// targetRows를 newMST3040_R01UsageList에 대체
			newMST3040_R01UsageList = newMST3040_R01UsageList.filter(item => item.orderIndex !== targetOrderIndex);
			newMST3040_R01UsageList.push(...targetRows);
			
			//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
			const newData = data.map(item => ({ ...defaultMST3040_R01UsageDto, ...item, 
				valueIndex: maxValueIndex++,
				orderIndex: targetOrderIndex,
				orderIndexSeq: newOrderIndexSeq,
			}));
			if (index !== undefined) {
				newMST3040_R01UsageList.splice(index, 0, ...newData);
			} else {
				newMST3040_R01UsageList.push(...newData);
			}
			
			return {
				...state,
				MST3040_R01UsageList: newMST3040_R01UsageList
			}
		}),
		removeMST3040_R01UsageList: (index: number) => set((state) => {
			const newMST3040_R01UsageList = [...state.MST3040_R01UsageList].filter((item) => item.valueIndex !== index);
			return {
				...state,
				MST3040_R01UsageList: newMST3040_R01UsageList
			}
		}),
		updateMST3040_R01UsageList: (valueIndex: number, data: MST3040_R01UsageDto) => set((state) => {
			return {
				...state,
				MST3040_R01UsageList: state.MST3040_R01UsageList.map(item =>
					item.valueIndex === valueIndex ? data : item
				)
			}
		}),

		selectedMST3040_R01Usage: undefined,
		setSelectedMST3040_R01Usage: (data: MST3040_R01UsageDto | undefined) => set((state) => {
			return {
				...state,
				selectedMST3040_R01Usage: data
			}
		}),
		initSelectedMST3040_R01Usage: () => set({ selectedMST3040_R01Usage: undefined }),
	
		originalMST3040_R01UsageList: [],
		setOriginalMST3040_R01UsageList: (data: MST3040_R01UsageDto[]) => set((state) => {
			let newList: MST3040_R01UsageDto[] = [];
			let valueAndOrderIndex = 1;
			data.forEach((item, index) => {
				newList.push({ 
					...defaultMST3040_R01UsageDto,
					...item,
					valueIndex: valueAndOrderIndex,
					orderIndex: valueAndOrderIndex,
					orderIndexSeq: valueAndOrderIndex
				});
				valueAndOrderIndex++;
			});
			return {
				...state,
				originalMST3040_R01UsageList: newList
			}
		}),
	

	// ====== 컬럼 상태(그리드) ======
	columnState: null,				setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),
	detailColumnState: null,		setDetailColumnState: (state: ColumnState[] | null) => set({ detailColumnState: state }),
	usageColumnState: null,			setUsageColumnState: (state: ColumnState[] | null) => set({ usageColumnState: state }),


	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),
	detailScrollTop: null,
	setDetailScrollTop: (top: number | null) => set({ detailScrollTop: top }),
	usageScrollTop: null,
	setUsageScrollTop: (top: number | null) => set({ usageScrollTop: top }),

	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),						
	modalVisible: false,			setModalVisible: (visible: boolean) => set({ modalVisible: visible }),
	detailFetchTrigger: false,
	setDetailFetchTrigger: (trigger: boolean) => set({ detailFetchTrigger: trigger }),

	// ====== 초기화 ======
	initData: () => set((state) => ({
		...state,
		MST3040_R01Filter: defaultMST3040_R01Filter,
		MST3040_R01PastFilter: defaultMST3040_R01Filter,
		MST3040_R01List: [],
		selectedMST3040_R01: undefined,
		MST3040_R01DetailList: [],
		deletedMST3040_R01DetailList: [],
		selectedMST3040_R01DetailList: [],
		editMST3040_R01: defaultMST3040_R01HeaderDto,
		editMST3040_R01Detail: defaultMST3040_R01DetailDto,
		allCount: 0,
		detailFetchTrigger: false,
		scrollTop: null,
		detailScrollTop: null,
		usageScrollTop: null,
		
	})),

}));
